import React from "react";

const Home = () => {
  return (
    <>
      <div className=" home text-center ">
        <div className="container">
          <div className="welcome-text">
            <h2 className="mb-4">Welcome To Cloothes</h2>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque
              dolores neque reprehenderit
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
